
// NATIVE 

import dayjs from "dayjs";
import { types } from "../types/types";
import { enviroments } from "../../enviroments/enviroments";
import { storageGetAssignedUserPermissions } from "./Storage";
import { diccionario } from "../../components/dictionary/dictionary";


// INSTALLED 
import { QueryPagination } from '../interfaces';

// CUSTOM 


export const getUrlBase = () => {
    return enviroments.URL_BASE;
}

export const buildQuery = ({
    page = 1,
    take = 10,
    status = 1,
    param = '',
}: QueryPagination = {}) =>
    new URLSearchParams({
        page: String(page),
        take: String(take),
        status: String(status),
        param,
    }).toString();

export const setDateValid = (date:string) => {

    return dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
    
}


export const eachWordUpper = (sentence:string) => {

    if( !sentence || sentence === '') return 'N/A';
    const wordLower = sentenceToLower(sentence);

    

    const words = wordLower.split(" ");

    for (let i = 0; i < words.length; i++) {
        
        if (words[i][0]) {
            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }
        
        
    }
    return words.join(" ");

}


export const sentenceToLower = ( sentence:string ) => {
   
     return sentence.toLocaleLowerCase();
}



//                                  nombre modulo    sub modulo       permission       n-submodulos
export const hasPemissions = async( module:string, submodule: string, action: string, ...extraSubmodules: string[] ) => {
    
    const permissions =  await storageGetAssignedUserPermissions();

    if (!permissions || !Array.isArray(permissions)) return false;

    // Nivel 1: Buscar el Módulo principal
    const moduleNode = permissions.find((p: any) => p.permission_slug === module);
    if (!moduleNode) return false;

    // Nivel 2: Buscar el Submódulo
    let currentNode = moduleNode.childrens?.find((c: any) => c.slug === submodule);
    if (!currentNode) return false;

    // Niveles 3 a N: Navegar dinámicamente si se pasan más argumentos
    // Filtramos strings vacíos por si alguien llamó hasPemissions(..., ..., ..., '')
    const path = extraSubmodules.filter(Boolean);

    for (const slug of path) {
        if (!currentNode.childrens || currentNode.childrens.length === 0) {
            return false; // Esperábamos más niveles pero no hay hijos
        }
        const nextNode = currentNode.childrens.find((c: any) => c.slug === slug);
        if (!nextNode) {
            return false; // No se encontró el subnivel exacto
        }
        currentNode = nextNode;
    }

    // Finalmente, verificar si la acción existe en el nodo destino
    return currentNode.actions?.includes(action) || false;
}



                                      // key storage                   // id element
// export const updateStatusRowTblPaginate = async ( storage: string, elementID: string, status:any) => {
    
//     const element = await AsyncStorage.getItem( storage ) || '{}';


//     const elementObject = JSON.parse(element);

//     if ( Object.keys(elementObject).length > 0  ) {

//         if ( elementObject.data ) {
             
//              const parameters = elementObject.data.map( (element:any) => {

//                  if ( element.id == elementID ) {
//                       element.status = status;
//                  }

//                  return element;

//              });

//              elementObject.data = parameters;


//              await AsyncStorage.setItem(types.storage.parametrosStorage, JSON.stringify(elementObject));

//              return {
//                  ok: true,
//                  data: elementObject
//              }
             
//         }


//         return {
//             ok: false,
//             data: []
//         }
        
        
         
//     }


// }





export const updateStatusTableAndUpdateRedux = async ( elementID: string, status: number, data:any) => {
    
   


    const elementObject = JSON.parse(JSON.stringify(data));

    if ( Object.keys(elementObject).length > 0  ) {

        if ( elementObject.data ) {
             
             const parameters = elementObject.data.map( (element:any) => {

                 if ( element.id == elementID ) {
                      element.status = status;
                 }

                 return element;

             });

             elementObject.data = parameters;


             return {
                 ok: true,
                 data: elementObject
             }
             
        }


        return {
            ok: false,
            data: []
        }
        
        
         
    }


}


export const updateStatusRowTblPaginateRedux = async ( data: string, elementID: string, status:any) => {
    

    const elementObject:any = JSON.parse(JSON.stringify(data));


    if ( Object.keys(data).length > 0  ) {

        if ( elementObject.data ) {
             
             const parameters = elementObject.data.map( (element:any) => {

                 if ( element.id == elementID ) {
                      element.status = status;
                 }

                 return element;

             });

             elementObject.data = parameters;


             if ( status == 0) {
                  elementObject.activosTotal   = elementObject.activosTotal - 1;
                  elementObject.inactivosTotal = elementObject.inactivosTotal + 1;
             }

             if ( status == 1) {
                elementObject.activosTotal   = elementObject.activosTotal + 1;
                elementObject.inactivosTotal = elementObject.inactivosTotal - 1;
             }


            //  await AsyncStorage.setItem(types.storage.parametrosStorage, JSON.stringify(elementObject));

             return {
                 ok: true,
                 data: elementObject
             }
             
        }


        return {
            ok: false,
            data: []
        }
        
        
         
    }


}







/**
 * Checks and formats the permissions for a user based on a given permissions list.
 * 
 * @param {any} permissionsList - The list of permissions to check against.
 * @param {any} permisssionsUser - The user object containing the user's permissions.
 * @returns {Promise<any>} - A promise that resolves to the formatted permissions list with updated `isChecked` and `actions` properties.
 * 
 * @example
 * const permissionsList = [
 *   { permission_slug: 'modulo.thumano', childrens: [{ slug: 'modulo.empleados', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 *   { permission_slug: 'modulo.configuracion', childrens: [{ slug: 'modulo.logacciones', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] }
 * ];
 * 
 * const permisssionsUser = {
 *   user: {
 *     permissions: [
 *       { permission_slug: 'modulo.thumano', childrens: [{ slug: 'modulo.empleados', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 *     ]
 *   }
 * };
 * 
 * const formattedPermissions = await userHasPermissionFormated(permissionsList, permisssionsUser);
 * // Output:
 * // [
 * //   { permission_slug: 'modulo.thumano', isChecked: true, childrens: [{ slug: 'modulo.empleados', isChecked: true, actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 * //   { permission_slug: 'modulo.configuracion', isChecked: false, childrens: [{ slug: 'modulo.logacciones', isChecked: false, actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] }
 * // ]
 */
export const userHasPermissionFormated = async (permissionsList: any, permissionsUser: any) => {
    const permissionObject = JSON.parse(JSON.stringify(permissionsList));
    const userPermissions = JSON.parse(JSON.stringify(permissionsUser.user.permissions));



    if (!Array.isArray(permissionObject) || !Array.isArray(userPermissions)) {
        return permissionObject;
    }

    for (const userPerm of userPermissions) {
        const matchedPerm = permissionObject.find((perm: any) => perm.permission_slug === userPerm.permission_slug);

        if (matchedPerm) {
            matchedPerm.isChecked = true;

            for (const userChild of userPerm.childrens || []) {
                const matchedChild = matchedPerm.childrens.find((child: any) => child.slug === userChild.slug);

                if (matchedChild) {
                    matchedChild.isChecked = true;

                    // Asignar siempre un array (vacío o con valores) desde el usuario
                    matchedChild.actions = Array.isArray(userChild.actions) ? [...userChild.actions] : [];
                }
            }
        }
    }

    
    return permissionObject;
};









/**
 * Checks and formats the permissions for a user based on a given permissions list.
 * 
 * @param {any} permissionsList - The list of permissions to check against.
 * @param {any} permisssionsUser - The user object containing the user's permissions.
 * @returns {Promise<any>} - A promise that resolves to the formatted permissions list with updated `isChecked` and `actions` properties.
 * 
 * @example
 * const permissionsList = [
 *   { permission_slug: 'modulo.thumano', childrens: [{ slug: 'modulo.empleados', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 *   { permission_slug: 'modulo.configuracion', childrens: [{ slug: 'modulo.logacciones', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] }
 * ];
 * 
 * const permisssionsUser = {
 *   user: {
 *     permissions: [
 *       { permission_slug: 'modulo.thumano', childrens: [{ slug: 'modulo.empleados', actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 *     ]
 *   }
 * };
 * 
 * const formattedPermissions = await userHasPermissionFormated(permissionsList, permisssionsUser);
 * // Output:
 * // [
 * //   { permission_slug: 'modulo.thumano', isChecked: true, childrens: [{ slug: 'modulo.empleados', isChecked: true, actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] },
 * //   { permission_slug: 'modulo.configuracion', isChecked: false, childrens: [{ slug: 'modulo.logacciones', isChecked: false, actions: [ 'view', 'edit', 'create', 'delete', 'restore' ] }] }
 * // ]
 */
export const userHasPermissionFormatedUser = async ( user_permissions:any, customer_permissions:any,  ) => {


    
    const customerPermissions:any = JSON.parse(JSON.stringify(customer_permissions));
    const usersPermissions:any = JSON.parse(JSON.stringify(user_permissions));

 

    if ( customerPermissions.length > 0 && usersPermissions.length > 0  ) {

       
        // ESTA FUNCION SOLO AGREGA LA PROPIEDAD isChecked AL ARRAY 
        // LA IDEA ES QUE RECORRA LOS PERMISOS DE USUARIO Y PONGA LA PROPIEDAD isChecked EN true 
        // EN customerPermissions PARA QUE ME MUESTRE TODOS LOS PERMISOS DE USUARIO PERO CHECKEADOS
        // SOLO LOS DEL USUARIO
        usersPermissions.forEach( (userPermissions:any) => {

            customerPermissions.forEach( (customerPermissions:any) => {

              

                if (customerPermissions.permission_slug === userPermissions.permission_slug) {

                    customerPermissions.isChecked = true;
                    // COMPARAR CHILDRENS 
                    if ( userPermissions.childrens.length > 0 && customerPermissions.childrens.length > 0 ) { 
                        compareChildren(userPermissions.childrens, customerPermissions.childrens);
                    }
                }else{
                    customerPermissions.isChecked = false;
                }

            });

            
        });



        // COMO SE DEBE FORMATEAR OSEA PONERLE ACTIONS SI EXISTEN SIEMPRE LOS PRINCIPALES 
        // SON LOS DEL CLIENTE, PORQUE SIEMPRE SE VAN A MOSTRAR ENTONCES SE RECORRE PRIMERO 
        // LOS PERMISOS DEL CLIENTE, YA INDEPENDIENTEMENTE DE LOS DEL USUARIO PORQUE DEBE MOSTRARLOS TODOS 
        // PERO CHECKEAR LAS ACCIONES QUE COINCIDAN CON LOS PERMISOS DEL USUARIOS 
        customerPermissions.forEach( (customerPermissions:any) => {

            usersPermissions.forEach( (userPermissions:any) => {

                // COMPARAR CHILDRENS 
                if ( customerPermissions.childrens.length > 0 && userPermissions.childrens.length > 0 ) { 
                    compareChildrenActions(customerPermissions.childrens, userPermissions.childrens);
                }
            
            });

        });

        



    }

 

    let permissionsFormated = formatUnchekedChildrens(customerPermissions);

    console.log('permissionsFormated ',permissionsFormated)
    
    return JSON.parse( JSON.stringify(permissionsFormated) );
    // return customerPermissions;
       


}


function formatUnchekedChildrens(customerPermissions:any){
   
     customerPermissions.forEach( (element:any) => {

      
        
        
         if ( !element.isChecked && element.childrens.length > 0) {

              

             element.childrens.forEach( (child:any) => {

                 child.isChecked = false;

                //  LIMPIA LOS ACTION DE LOS SUB CHILDRES COMO POR EJEMPLO NOVEDADES
                 child.childrens.forEach( (subChild:any) => {
                     subChild.actions = [];
                 })
                 

             });
         }

     });

     return customerPermissions;
}



function compareChildren(userChildren: any[], customerChildren: any[]) {


  customerChildren.forEach((customerChild) => {

    
    const matchingUserChild = userChildren.find((userChild) => userChild.slug === customerChild.slug);
  
    if (matchingUserChild) {
      customerChild.isChecked = true;

      // Procesar recursivamente si hay hijos
      if (
        Array.isArray(matchingUserChild.childrens) &&
        Array.isArray(customerChild.childrens)
      ) {
        compareChildren(matchingUserChild.childrens, customerChild.childrens);
      }
    } else {
      customerChild.isChecked = false;
      customerChild.actions = [];

      if (Array.isArray(customerChild.childrens)) {
       
        customerChild.childrens.forEach((child: any) => {
           
          child.isChecked = false;
          child.actions = [];
        });
      }
    }
  });
}



function compareChildrenActions( customerChildren:any, userChildren:any ) {

    
    customerChildren.forEach( ( customerChild:any) => {

        const result = userChildren.find( (element:any) => element.slug == customerChild.slug );

        if (result) {
            customerChild.actions = result.actions;
        }else{
            customerChild.actions = [];
        }


        userChildren.forEach( ( userChild:any) => {


            if ( customerChild.childrens && userChild.childrens.length > 0 ) {
                compareChildrenActions(customerChild.childrens, userChild.childrens);
                
            }

        });

        

            
            
        

    });

    
}





export const userHasPermissionFormatedEdit = async (
  user_permissions: any[],
  customer_permissions: any
) => {
  user_permissions.forEach((module: any) => {
    if (customer_permissions[module.permission_slug]) {
      // CHECKEA EL MODULO PRINCIPAL
      customer_permissions[module.permission_slug][module.permission_slug] =
        module.isChecked ? true : false;

      // RECORRE CHILDRENS
      if (module.childrens && module.childrens.length > 0) {
        module.childrens.forEach((submodule: any) => {
          if (submodule.isChecked) {
            customer_permissions[module.permission_slug].subModulesChecked[
              submodule.slug
            ] = true;
          }

          // ACTIONS DE SUBMODULE
          if (
            customer_permissions[module.permission_slug].childrensChecked[
              submodule.slug
            ]
          ) {
            if (submodule.actions) {
              submodule.actions.forEach((action: any) => {
                customer_permissions[module.permission_slug].childrensChecked[
                  submodule.slug
                ][action] = true;
              });
            }
          }

          // RECORRE SUBCHILDRENS
          if (submodule.childrens && submodule.childrens.length > 0) {
            submodule.childrens.forEach((subSubmodule: any) => {
              if (subSubmodule.isChecked) {
                customer_permissions[module.permission_slug].subSubModulesChecked[
                  subSubmodule.slug
                ] = true;
              }

              if (
                customer_permissions[module.permission_slug].subChildrensCheked[
                  subSubmodule.slug
                ]
              ) {
                if (subSubmodule.actions) {
                  subSubmodule.actions.forEach((action: any) => {
                    customer_permissions[module.permission_slug]
                      .subChildrensCheked[subSubmodule.slug][action] = true;
                  });
                }
              }
            });
          }
        });
      }
    }
  });

  
  // retornamos el customer_permissions modificado
  return JSON.parse(JSON.stringify(customer_permissions));
};


// export const userHasPermissionFormatedEdit = async ( user_permissions:any, customer_permissions:any  ) => {
    
//     console.log('cheuqcho')
//     user_permissions.forEach( (module:any) => {

        

//         if ( customer_permissions[module.permission_slug] ) {

//             //  CHECKEA EL MODULO PRINCIPAN 
//              ( module.isChecked) ? customer_permissions[module.permission_slug][module.permission_slug] = module.isChecked : customer_permissions[module.permission_slug][module.permission_slug] = false;
             
             
//             //  VERIFICA QUE TENGA CHILDRES Y LOS RECORRE PARA CHECKEAR EL MODULO HIJO CAMBIA EL VALUE EN subModulesChecked SI EL MODULO ESTA CHECKEADO 
//              if ( module.childrens && module.childrens.length > 0 ) {

                 
//                 module.childrens.forEach( (submodule:any) => {

//                     if ( submodule.isChecked ) {
//                          customer_permissions[module.permission_slug].subModulesChecked[submodule.slug] = true;
//                     }
                    
               
//                     // BUSCA EN LOS CHILDRESN PARA ASIGNAR LAS ACTIONS DE LOS CHILDRENS DE CADA MODULO 
//                     if ( customer_permissions[module.permission_slug].childrensChecked[submodule.slug] ) {
                         
                        
//                         if (submodule.actions) {
                            
//                             submodule.actions.forEach( (action:any) => {
//                                 customer_permissions[module.permission_slug].childrensChecked[submodule.slug][action] = true;
//                             });

//                         }
                        
//                     } 
                    



//                     //  VERIFICA QUE TENGA CHILDRES Y LOS RECORRE PARA CHECKEAR EL MODULO HIJO CAMBIA EL VALUE EN subModulesChecked SI EL MODULO ESTA CHECKEADO 
//                     if ( submodule.childrens && submodule.childrens.length > 0 ) {

//                         submodule.childrens.forEach( (subSubmodule:any) => {
                          
//                             if ( subSubmodule.isChecked ) { 
//                                 customer_permissions[module.permission_slug].subSubModulesChecked[subSubmodule.slug] = true;
//                             }


//                             // BUSCA EN LOS CHILDRESN PARA ASIGNAR LAS ACTIONS DE LOS CHILDRENS DE CADA MODULO 
//                             if ( customer_permissions[module.permission_slug].subChildrensCheked[subSubmodule.slug] ) {
                                
                                
//                                 if (subSubmodule.actions) {
                                    
//                                     subSubmodule.actions.forEach( (action:any) => {
//                                         customer_permissions[module.permission_slug].subChildrensCheked[subSubmodule.slug][action] = true;
//                                     });

//                                 }
                                
//                             }
                          

//                         });
//                     } // END IF 

                     
//                 }); // END FOREACH

                
                
//              } // END IF CHILDRES
             
//         }


//     });

//     const data = JSON.parse( JSON.stringify(customer_permissions) );
//     return data;
    


// }





export const userHasPermissionFormatSave = async ( customer_permissions_formated:any,  modulesChecked:any, user_permissions:any   ) => {
    
    
    return JSON.parse( JSON.stringify(user_permissions) );

}



// SI EL MODULO ESTA MARCADO CHECKEADO LO PONE EN EL NUEVO ARRAY 
// SOLO DEVOLVERIA LOS CHECKEADOS DE UN ARRAY QUE SE LE PASE
export const formatCustomerPermissionToSave = async ( permissions:any ) => {

      let permissionsFomated:any = [];

      console.log('como si nada')
      console.log(permissions)

      for (let index = 0; index < permissions.length; index++) {

        if (permissions[index].isChecked) {
            permissionsFomated.push(permissions[index])
        }

        
      }


  
      return permissionsFomated;

}


export const userHasPermission = async ( permissionItemSlug:any, permissionsList:any) => {
    

    const elementObject:any = JSON.parse(JSON.stringify(permissionsList));


    if ( permissionsList.length > 0  ) {

        
             
        const permissionExist = elementObject.map( (element:any) => {

            if ( element.permission_slug == permissionItemSlug ) {
                return true;
            }

        });


        return permissionExist;
             
        
         
    }

    return false;


}





export const userHasSubmodulePermission = async ( permissionItemSlugParent:any, permissionItemSlugChildern:any, permissions:any) => {
    

    // const elementObject:any = JSON.parse(JSON.stringify(permissionsList));


    if ( permissions.length > 0  ) {

        // console.log('chupepeppeper hasPermissions ', hasPermissions)
        
              
        for (let index = 0; index < permissions.length; index++) {
        
            if ( permissions[index].permission_slug == permissionItemSlugParent ) { 
                
                 for (let i = 0; i < permissions[index].childrens.length; i++) {
                    
                    

                     if ( permissions[index].childrens[i].slug == permissionItemSlugChildern ) {
                       
                        //   if ( permissions[index].childrens[i].actions.includes(action) ) {
                        //        return true;
                        //   }
                        return true;
   
                     }
                   
                 }
            }

            
           
       }
   
       return false;
             
        
         
    }

    return false;


}




export const closeSessionGlobal = async () => {

        await window.localStorage.removeItem(types.storage.userStorage);
        await window.localStorage.removeItem(types.storage.permissionsStorage);
        await window.localStorage.removeItem(types.storage.userPermissionsStorage);

}

// ============================================================================
// FUNCIONES DE FECHAS Y HORAS
// ============================================================================

// ejemplo: llega "23:00", "01:15" return { horas: 2, minutos: 15 }
export const calcularDiferenciaHoras = ( horaInicio:string, horaFin:string ) => {
    
    const [hInicio, mInicio] = horaInicio.split(":").map(Number);
    const [hFin, mFin] = horaFin.split(":").map(Number);

    // Convertir ambas horas a minutos totales
    const minutosInicio = hInicio * 60 + mInicio;
    const minutosFin = hFin * 60 + mFin;

    // Calcular diferencia en minutos
    let diferenciaMinutos = minutosFin - minutosInicio;

    // Si la diferencia es negativa, cruzó medianoche
    if (diferenciaMinutos < 0) {
        diferenciaMinutos += 24 * 60;
    }

    const horas = Math.floor(diferenciaMinutos / 60);
    const minutos = diferenciaMinutos % 60;

    return { horas, minutos };
}

// ejemplo: llega "2026-07-26T12:00:00Z" return "26 de julio de 2026"
export const formatDateToYmd = (dateParameter: Date) => {

    if ( !dateParameter || dateParameter == undefined ) {
        return 'N/A';
    }
    
    const date = new Date(dateParameter);

    // Opciones de formato
    const options:any = { day: 'numeric', month: 'long', year: 'numeric' };

    // Convertir a formato deseado
    return date.toLocaleDateString('es-CO', options);

}



export const formatDateToYmdNumeric = (dateParameter: Date) => {

    if ( !dateParameter || dateParameter == undefined ) {
        return 'N/A';
    }
    
    const date = new Date(dateParameter);

    const dia = date.getDate().toString().padStart(2, '0'); // Día con 2 dígitos
    const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // Mes con 2 dígitos
    const anio = date.getFullYear(); // Año con 4 dígitos

    return `${dia}/${mes}/${anio}`;

}




export const firstLetterUpperCase = (texto:string) => {

    // Verifica si el texto no está vacío
    if (!texto) return texto;

  
    // Convierte todo a minúscula y luego la primera letra de cada palabra a mayúscula
    return texto
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}


// RECORRE LOS PERMISOS PARA VER SI EL PATH DE LA URL QUE SE RECIBE POR PARAMETRO CONINCIDE Y SE DEVUELVE ESE INDEX 
// PARA QUE ABRA EL MENU PARENT, SI NO LO ENCUENTRA ENTRA EN EL ELSE PARA SABER SI ES UN SUB ARRAY DEL ARRAY  Y DEVUELVA 
// EL INDEX DEL PADRE Y DEL SUB MENU 
export const getIndexParentMenu = async( parentSlug:string ) => {

    const permissions =  await storageGetAssignedUserPermissions();

    for (let index = 0; index < permissions.length; index++) { 
            
            for (let i = 0; i < permissions[index].childrens.length; i++) {
                
                if ( permissions[index].childrens[i].to == parentSlug ) { 
                    return { parentIndex: index, childIndex: i, subChildIndex: -1 };
                }

                if (permissions[index].childrens[i].childrens && permissions[index].childrens[i].childrens.length > 0) {
                    for (let j = 0; j < permissions[index].childrens[i].childrens.length; j++) {
                        if (permissions[index].childrens[i].childrens[j].to == parentSlug) {
                            return { parentIndex: index, childIndex: i, subChildIndex: j };
                        }
                    }
                }
            }
    }
    return { parentIndex: 700, childIndex: -1, subChildIndex: -1 };

}



export const formatPhoneNumber = (phone: string | number) => {
  // Asegura que sea string y elimina cualquier carácter no numérico
  const cleaned = phone.toString().replace(/\D/g, '');

  // Extrae las partes
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);
  
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}-${match[4]}`;
  }

  return phone.toString(); // Retorna original si no coincide el patrón
}

export const formatShortPhoneNumber = (phone: string | number) => {

 if ( !phone ) {
    return 'N/A';
  }

  const cleaned = phone.toString().replace(/\D/g, '');

  const match = cleaned.match(/^(\d{3})(\d{2})(\d{2})$/);

  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  return phone.toString();
}






export const getHoursFromDate = (fecha:string) => {

    if ( !fecha || fecha == '') {
         return fecha;
    }

    const dateObj = new Date(fecha.replace(" ", "T")); // convertir a objeto Date

    const opciones:any = { hour: 'numeric', minute: '2-digit', hour12: true };
    return dateObj.toLocaleString('en-US', opciones);

}





  //  await validateResponse(response, 'crear compañia', {
  //                             setMsgSnack,
  //                             setAlertSnack,
  //                             setModalSessionExpired,
  //                         }, true);
export const validateResponse = async (
  response: any,
  textActionConcat: string,
  handlers: {
    setMsgSnack: (msg: any) => void,
    setAlertSnack: (flag: boolean) => void,
    setModalSessionExpired: (flag: boolean) => void
  },
  showSuccessSnack: boolean = false // <-- opcional
) => {


  if (response.code === 401) {
    localStorage.removeItem('lastSelectedQypht');
    await closeSessionGlobal();
    handlers.setModalSessionExpired(true);
    return false;
  }

  const getErrorMessage = (errors: any) => {
    if (Array.isArray(errors)) return errors.join('. ');
    if (typeof errors === 'string') return errors;
    return 'Error general';
  };

  if (!response.ok && [403, 404, 409].includes(response.code)) {
    handlers.setMsgSnack({ msg: getErrorMessage(response.errors) + ' ' + textActionConcat, status: 'error' });
    handlers.setAlertSnack(true);
    return false;
  }

  if (!response.ok && response.code === 400) {
    handlers.setMsgSnack({ msg: getErrorMessage(response.errors) + ' ' + textActionConcat, status: 'error' });
    handlers.setAlertSnack(true);
    return false;
  }

  if (!response.ok && response.code === 500) {
    handlers.setMsgSnack({ msg: getErrorMessage(response.errors) + ' ' + textActionConcat, status: 'error' });
    handlers.setAlertSnack(true);
    return false;
  }

  if (response.ok && showSuccessSnack) {
    handlers.setMsgSnack({ msg: response.message, status: 'success' });
    handlers.setAlertSnack(true);
  }

  return true;
};




/**
 * Ejecuta una serie de funciones sobre un valor inicial.
 * @param {...Function} funciones - Las funciones a aplicar.
 * @param {any} valor - El valor original (el texto).
 */
export const usarFuncionesComposicion = (...args: any) => {
  // El último argumento es el valor (row.name)
  const valorInicial = args.pop();
  // El resto son las funciones (corregirTexto, firstLetterUpperCase)
  const funciones = args;

  return funciones.reduce((valorActual: any, funcion: any) => {
    return funcion(valorActual);
  }, valorInicial);

};



export const corregirTexto = (valor: any) => {

  if (!valor) return valor;
  let textoCorregido = valor;

  for (let sinTilde in diccionario) {
    const conTilde = diccionario[sinTilde];
    // \b busca la palabra exacta. "gi" es para ignorar mayúsculas
    const regex = new RegExp(`\\b${sinTilde}\\b`, "gi");

    textoCorregido = textoCorregido.replace(regex, (match: any) => {
      // Mantener mayúscula inicial si existía
      if (match[0] === match[0].toUpperCase()) {
        return conTilde.charAt(0).toUpperCase() + conTilde.slice(1);
      }
      return conTilde;
    });
  }
  return textoCorregido;
};




export const validateQiResponse = async (
  response: any,
  textActionConcat: string,
  handlers: {
    setMsgSnack: (msg: any) => void,
    setAlertSnack: (flag: boolean) => void,
    setModalSessionExpired: (flag: boolean) => void,
    setMessagesAlerts?: (msg: any) => void
  },
  showSuccessMessage = false
) => {

  if (response.code === 401) {
    localStorage.removeItem('lastSelectedQypht');
    await closeSessionGlobal();
    handlers.setModalSessionExpired(true);
    return false;
  }

  const getErrorMessage:any = (err: any) => {
    if (typeof err === 'string') return err;
    if (Array.isArray(err)) return getErrorMessage(err[0]);
    if (typeof err === 'object' && err !== null) {
      return Object.values(err).find(v => typeof v === 'string') || JSON.stringify(err);
    }
    return '';
  };

  const errorMessage = getErrorMessage(response.errors || response.message || 'Error');

  if (!response.ok && response.code === 400) {
    if (handlers.setMessagesAlerts && Array.isArray(response.errors)) {
      const errors = response.errors.map((element: any) => ({
        type: 'error',
        text: typeof element === 'string' ? element : getErrorMessage(element)
      }));
      handlers.setMessagesAlerts(errors);
    } else {
      handlers.setMsgSnack({ msg: `${errorMessage} ${textActionConcat}`.trim(), status: 'error' });
      handlers.setAlertSnack(true);
    }
    return false;
  }

  if (!response.ok && [403, 404, 409].includes(response.code)) {
    handlers.setMsgSnack({ msg: `${errorMessage} ${textActionConcat}`.trim(), status: 'error' });
    handlers.setAlertSnack(true);
    return false;
  }

  if (!response.ok && response.code === 500) {
    const msg = (response.errors && Array.isArray(response.errors) && response.errors.length > 0)
      ? getErrorMessage(response.errors)
      : 'Consulte al administrador del sistema';

    handlers.setMsgSnack({ msg, status: 'error' });
    handlers.setAlertSnack(true);
    return false;
  }

  if (response.ok) {
    if (showSuccessMessage) {
      const successMsg = typeof response.message === 'string' ? response.message : 'Operación exitosa';
      handlers.setMsgSnack({ msg: `${successMsg} ${textActionConcat}`.trim(), status: 'success' });
      handlers.setAlertSnack(true);
    }
    return false;
  }

  return true;
};





/**
 * Formatea el saldo de créditos disponible.
 * Muestra siempre 2 decimales.
 *
 * Ejemplos:
 * formatCredits(2498.99895088) => "2.499,00"
 * formatCredits(2500)          => "2.500,00"
 * formatCredits(15.5)          => "15,50"
 */
export function formatCredits(value: number | string | null | undefined): string {
  if (value == null || value === '') {
    return '0,00';
  }

  return new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value));
}

/**
 * Formatea el consumo de créditos.
 * Conserva hasta 6 decimales y elimina ceros innecesarios.
 *
 * Ejemplos:
 * formatCreditConsumption(0.00104923) => "0,001049"
 * formatCreditConsumption(0.05)       => "0,05"
 * formatCreditConsumption(1.256789)   => "1,256789"
 * formatCreditConsumption(15)         => "15"
 */
export function formatCreditConsumption(
  value: number | string | null | undefined,
): string {
  if (value == null || value === '') {
    return '0';
  }

  return new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  }).format(Number(value));
}



/**
 * Formatea el saldo de créditos.
 *
 * Ejemplos:
 * 2500              => 2.500,00
 * 2499.50           => 2.499,50
 * 2498.99982353     => 2.498,999824
 * 15                => 15,00
 * 0.00104923        => 0,001049
 */
export function formatCreditsPresicion(value: number | string | null | undefined): string {
  if (value == null || value === '') {
    return '0,00';
  }

  const number = Number(value);

  // Si la parte decimal es muy pequeña, mostrar hasta 6 decimales
  const decimals =
    Math.abs(number - Math.trunc(number)) < 0.01 ? 6 : 2;

  return new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: decimals,
  }).format(number);
}